import { useAuth } from 'src/contexts/AuthContext';
import { useCheckIn } from 'src/components/tournaments/check-in/CheckInContext';

export function useCheckInFunc() {
  const { user } = useAuth();
  const { gameId, tournamentId } = useCheckIn();

  const checkInFn = async (entireTeam = false) => {
    if (!user) {
      throw new Error(
        'wrappedCheckIn cannot be called without an authenticated user actively signed in.',
      );
    }
    //if the user has not updated their username, require them to do so
    const { checkIn } = await import(
      '../../../firebaseCloud/tournament/checkIn'
    );
    await checkIn({
      gameId,
      userId: user.uid,
      tournamentId,
      entireTeam,
    });
  };

  return { checkInFn };
}
